import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const selectedWorkItemId = "selectedWorkItemId";
export interface IConsolePageState {
    isDashboardPanelOpen: boolean;
    isTaskListCollapsed: boolean;
    isTaskManagerOpen: boolean;
    selectedWorkItemId: string;
    customerNames: { [id: string]: string; },
    unreadMessageCounts: { [id: string]: number; },
};

const initialState: IConsolePageState = {
    isDashboardPanelOpen: false,
    isTaskListCollapsed: false,
    isTaskManagerOpen: false,
    selectedWorkItemId: localStorage.getItem(selectedWorkItemId) || '',
    customerNames: {},
    unreadMessageCounts: {},
};

const consolePageSlice = createSlice({
    initialState,
    name: 'consolePage',
    reducers: {
        toggleDashboardCollapsed(state, { payload }: PayloadAction<boolean>) {
            state.isDashboardPanelOpen = payload;
        },
        toggleTaskListCollapsed(state, { payload }: PayloadAction<boolean>) {
            state.isTaskListCollapsed = payload;
        },
        setMobileView(state, { payload }: PayloadAction<boolean>) {
            if (state.isDashboardPanelOpen && payload) {
                state.isDashboardPanelOpen = !payload;
            }
            state.isTaskListCollapsed = payload;
        },
        setSelectedWorkItemId(state, { payload }: PayloadAction<string>) {
            state.selectedWorkItemId = payload;
            localStorage.setItem(selectedWorkItemId, payload);
        },
        toggleTaskManagerOpen(state) {
            state.isTaskManagerOpen = !state.isTaskManagerOpen;
        },
        addCustomerName(state, { payload }: PayloadAction<{ id: string, name: string }>) {
            state.customerNames[payload.id] = payload.name;
        },
        updateUnreadMessageCount(state, { payload }: PayloadAction<{ conversationId: string, count: number }>) {
            state.unreadMessageCounts[payload.conversationId] = payload.count;
        }
    },
});

export const {
    toggleDashboardCollapsed,
    toggleTaskListCollapsed,
    toggleTaskManagerOpen,
    setSelectedWorkItemId,
    setMobileView,
    addCustomerName,
    updateUnreadMessageCount,
} = consolePageSlice.actions;

export default consolePageSlice.reducer;